import * as Yup from "yup";

export const AdApisValidationSchema = Yup.object().shape({
  name: Yup.string().trim().required("name is required"),
  email: Yup.string()
    .trim()
    .email("Invalid email address")
    .required("Email is required"),
});

export const AdUnitValidations = Yup.object().shape({
  id: Yup.string().trim().required("Unit id is required."),
  name: Yup.string().trim().required("Unit name is required."),
  code_url: Yup.string().trim().required("Unit id is required."),
  ad_format: Yup.string().trim().required("Select an ad format."),
  type: Yup.string().trim().required("Select an ad type."),
});
